import { action } from 'typesafe-actions';
import {
  CLAIMS_TYPES,
  GetClaims,
  ClaimType,
  Status,
  States,
  SearchClaim,
  IClaim,
  StepClaimStatus,
  StatusAction,
  TrfRem,
} from './types';

export const toggleOpenModalAction = (open?: boolean) =>
  action(CLAIMS_TYPES.TOGGLE_OPEN_MODAL, open);

export const cleanClaimsAction = () => action(CLAIMS_TYPES.CLEAN_CLAIMS);

export const searchClaimsAction = () =>
  action(CLAIMS_TYPES.SEARCH_CLAIMS_REQUEST);

export const searchClaimsCompleted = (claims: SearchClaim[]) =>
  action(CLAIMS_TYPES.SET_SEARCH_CLAIMS, claims);

export const getClaimsByTypeAction = (props: GetClaims) =>
  action(CLAIMS_TYPES.GET_CLAIMS_BY_TYPE_REQUEST, props);

export const getClaimsByStatusAction = (props: GetClaims) =>
  action(CLAIMS_TYPES.GET_CLAIMS_BY_STATUS_REQUEST, props);

export const setClaimsByStatus = (props: IClaim[], status: string) => {
  const TYPE = `${CLAIMS_TYPES.SET_CLAIMS_BY_STATUS}_${status}`;
  return action(TYPE, props);
};

export const cleanTimelineAction = () => action(CLAIMS_TYPES.CLEAN_TIMELINE);

export const getClaimByIdAction = (id: string) =>
  action(CLAIMS_TYPES.GET_CLAIM_BY_ID, id);

export const setClaimByIdAction = (claim: IClaim) =>
  action(CLAIMS_TYPES.SET_CLAIM_BY_ID, claim);

export const getStepsByIdAction = (claimId: string) =>
  action(CLAIMS_TYPES.GET_STEPS_BY_CLAIM_ID, claimId);

export const setStepsByClaimId = (stepsClaim: StepClaimStatus[]) =>
  action(CLAIMS_TYPES.SET_STEPS_BY_CLAIM_ID, stepsClaim);

export const getClaimsActive = (claims: ClaimType) =>
  action(CLAIMS_TYPES.GET_CLAIMS_ACTIVE, claims);

export const getClaimsCompleted = (claims: ClaimType) =>
  action(CLAIMS_TYPES.GET_CLAIMS_COMPLETED, claims);

export const getClaimStatusAction = () =>
  action(CLAIMS_TYPES.GET_STATUS_REQUEST);

export const getClaimStatusCompleted = (status: Status[]) =>
  action(CLAIMS_TYPES.GET_STATUS, status);

export const getStatesAction = () => action(CLAIMS_TYPES.GET_STATES_REQUEST);

export const getStatesCompleted = (states: States[]) =>
  action(CLAIMS_TYPES.GET_STATES, states);

export const deleteDraftAction = (draftId: string) =>
  action(CLAIMS_TYPES.DELETE_DRAFT, draftId);

export const invalidActiveClaimsAction = () =>
  action(CLAIMS_TYPES.INVALID_ACTIVE_CLAIMS_RESPONSE);

export const getStatusActionsAction = (claimId: string) =>
  action(CLAIMS_TYPES.GET_STATUS_ACTIONS, claimId);

export const setStatusActionsAction = (statusAction: StatusAction) =>
  action(CLAIMS_TYPES.SET_STATUS_ACTIONS, statusAction);

export const setTimelineClaimId = (timelineClaimId: string) =>
  action(CLAIMS_TYPES.SET_TIMELINE_CLAIM_ID, timelineClaimId);

export const getTrfRemAction = (claimId: string) =>
  action(CLAIMS_TYPES.GET_TRF_REM_BY_CLAIM_ID, claimId);

export const setTrfRemAction = (trfRem: TrfRem[]) =>
  action(CLAIMS_TYPES.SET_TRF_REM_BY_CLAIM_ID, trfRem);
